import { motion } from 'framer-motion'
import { ArrowUpRight } from 'lucide-react'
import { projects } from '../data.ts'
import SectionHeading from './SectionHeading.tsx'
import React from 'react'

export default function Work() {
  return (
    <section id="work" className="relative py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <SectionHeading
          eyebrow="Selected work"
          title={<>Projects we're <span className="text-gradient">proud of</span></>}
          subtitle="A glimpse of the websites and apps we've shipped for businesses across industries."
        />

        <div className="mt-14 grid gap-6 md:grid-cols-2">
          {projects.map((p, i) => (
            <motion.article
              key={p.title}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: '-60px' }}
              transition={{ duration: 0.55, delay: (i % 2) * 0.1 }}
              className="group relative overflow-hidden rounded-2xl border border-white/10 bg-ink-900/60"
            >
              {/* Visual */}
              <div className={`relative h-52 overflow-hidden bg-gradient-to-br ${p.accent}`}>
                <div className="absolute inset-0 grid-bg opacity-40" />
                <div className="absolute inset-0 grid place-items-center">
                  <div className="w-3/4 rounded-xl border border-white/15 bg-ink-900/70 p-4 shadow-2xl backdrop-blur transition-transform duration-500 group-hover:scale-[1.04]">
                    <div className="mb-3 flex gap-1.5">
                      <span className="h-2.5 w-2.5 rounded-full bg-white/20" />
                      <span className="h-2.5 w-2.5 rounded-full bg-white/20" />
                      <span className="h-2.5 w-2.5 rounded-full bg-white/20" />
                    </div>
                    <div className="h-2 w-2/3 rounded bg-white/15" />
                    <div className="mt-2 h-2 w-1/2 rounded bg-white/10" />
                    <div className="mt-3 grid grid-cols-3 gap-2">
                      <div className="h-8 rounded bg-white/10" />
                      <div className="h-8 rounded bg-white/15" />
                      <div className="h-8 rounded bg-white/10" />
                    </div>
                  </div>
                </div>
                <span className="absolute left-4 top-4 rounded-full bg-ink-950/70 px-3 py-1 text-xs font-medium text-slate-200 backdrop-blur">
                  {p.category}
                </span>
                <span className="absolute right-4 top-4 grid h-10 w-10 place-items-center rounded-full bg-ink-950/70 text-white backdrop-blur transition-all duration-300 group-hover:bg-brand-500 group-hover:text-ink-950">
                  <ArrowUpRight size={18} />
                </span>
              </div>

              {/* Body */}
              <div className="flex items-start justify-between gap-4 p-6">
                <div>
                  <span className="text-xs font-medium uppercase tracking-wide text-brand-300">{p.tag}</span>
                  <h3 className="mt-1.5 font-display text-xl font-semibold text-white">{p.title}</h3>
                  <p className="mt-2 text-sm leading-relaxed text-slate-400">{p.description}</p>
                </div>
                <div className="shrink-0 text-right">
                  <div className="font-display text-2xl font-bold text-gradient">{p.metric}</div>
                  <div className="text-[11px] text-slate-500">{p.metricLabel}</div>
                </div>
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  )
}
